import { render, staticRenderFns } from "./DomainSummaryHeatmap.vue?vue&type=template&id=5a65f672&scoped=true"
import script from "./DomainSummaryHeatmap.vue?vue&type=script&lang=js"
export * from "./DomainSummaryHeatmap.vue?vue&type=script&lang=js"
import style0 from "./DomainSummaryHeatmap.vue?vue&type=style&index=0&id=5a65f672&prod&scoped=true&lang=css"
import style1 from "./DomainSummaryHeatmap.vue?vue&type=style&index=1&id=5a65f672&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65f672",
  null
  
)

export default component.exports